export default __webpack_public_path__ + "locales/vi/Profile.json?hash=a626fe0ef6c55d5c7045ffb8dd61212d";